import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

import Home from '../views/Home.vue';
import UploadsList from '../views/servorgs/uploads/UploadsList.vue';
import Signin from '../views/auth/Signin.vue';
import ForgotPassword from '../views/auth/ForgotPassword.vue';
import MetersList from '../views/servorgs/meters/MetersList.vue';
import MeterIndications from '../views/servorgs/meters/MeterIndications.vue';
import UpdatePassword from '../views/auth/UpdatePassword.vue';
import Contracts from '../views/Contracts.vue';
import KSK from '../views/KSK.vue';
import Profile from '../views/Profile.vue';
import Documents from '../views/Documents.vue';
import MetersReport from '../views/meters-report/MetersReport.vue';
import Prescription from '../views/Prescription.vue';
import PrescriptionOZP from '../views/PrescriptionOZP.vue';
import PrescriptionOZPDetail from '../views/PrescriptionOZPDetail.vue';
import RequestOZPDetail from '../views/ahs-requests/RequestOZPDetail.vue';
import ObjectHouses from '../views/ObjectHouses.vue';
import AddEditPrescription from '@/components/ui/AddEditPrescription.vue';
import DebtorsList from '@/views/debts-info/DebtorsList.vue';
import PreTrialNotices from '@/views/pre-trial-notices/PreTrialNotices.vue';
import CenterBosses from '@/views/center-bosses/CenterBosses.vue';
import ReportPreTrialNoticesIssued from '@/views/report/ReportPreTrialNoticesIssued.vue';
import ReportActsOfConnDiscon from '@/views/report/ReportActsOfConnDiscon.vue';
import StylusSign from '@/views/debts-info/StylusSign.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'Главная',
            icon: 'home',
            public: true
        }
    },
    {
        path: '/maintenance_works',
        name: 'MaintenanceWorks',
        component: () => import('../views/MaintenanceWorks'),
        meta: {
            public: true
        }
    },
    {
        path: '/signin',
        name: 'Signin',
        component: Signin,
        meta: {
            title: 'Вход',
            icon: 'star',
            public: true,
            onlyWhenLoggedOut: true,
            showInNavigation: false
        }
    },

    {
        path: '/signinFrame',
        name: 'SigninFrame',
        component: Signin,
        meta: {
            title: 'Вход фрэйм',
            icon: 'star',
            public: true,
            onlyWhenLoggedOut: false,
            showInNavigation: false
        }
    },
    {
        path: '/forgotPassword',
        name: 'ForgotPassword',
        component: ForgotPassword,
        meta: {
            title: 'Вход',
            icon: 'star',
            public: true,
            //onlyWhenLoggedOut: true,
            showInNavigation: false
        }
    },
    {
        path: '/updatePassword',
        name: 'UpdatePassword',
        component: UpdatePassword,
        meta: {
            title: 'Вход',
            icon: 'star',
            public: true,
            showInNavigation: false
        }
    },
    //
    {
        path: '/meters',
        name: 'MetersList',
        component: MetersList,
        meta: {
            title: 'Список ПУТЭ',
            icon: 'settings_input_composite',
            public: false,
            showInNavigation: true,
            action: 'readMetersList'
        }
    },
    {
        path: '/meters/:id',
        name: 'MeterIndications',
        component: MeterIndications,
        meta: {
            public: false,
            action: 'readMetersList'
        },
        props: true
    },
    {
        path: '/uploads',
        name: 'UploadsList',
        component: UploadsList,
        meta: {
            title: 'Передача показаний',
            icon: 'system_update_alt',
            public: false,
            showInNavigation: true,
            action: 'readUploadsList'
        }
    },
    {
        path: '/uploads/:id',
        name: 'UploadsDetail',
        component: () => import('../views/servorgs/uploads/UploadsDetail'),
        meta: {
            public: false,
            action: 'readPreviewData'
        }
    },
    {
        path: '/administration',
        name: 'Administration',
        component: () => import('../views/administration/Administration'),
        meta: {
            title: 'Управление пользователями',
            icon: 'account_circle',
            public: false,
            showInNavigation: true,
            action: 'readAdministration'
        }
    },
    {
        path: '/ksk-bindings',
        name: 'KSKBindings',
        component: () => import('../views/administration/KSKBindings'),
        meta: {
            title: 'КСК дома',
            public: false,
            showInNavigation: true,
            action: 'readAdministration'
        }
    },
    {
        path: '/meters-report',
        name: 'MetersReport',
        component: MetersReport,
        meta: {
            title: 'reports.tabTitle',
            icon: 'print',
            public: false,
            showInNavigation: true,
            action: 'readMetersReport'
        }
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile,
        meta: {
            title: 'Профиль',
            icon: 'account_circle',
            public: false,
            showInNavigation: false
        }
    },
    {
        path: '/test',
        name: 'Test',
        component: () => import('../views/Test'),
        meta: {
            onlyWhenLoggedOut: false,
            public: false
        }
    },
    {
        path: '/contracts',
        name: 'Contracts',
        component: Contracts,
        meta: {
            title: 'Договоры',
            icon: 'account_circle',
            public: false,
            showInNavigation: true,
            action: 'contracts'
        }
    },
    {
        path: '/ksk',
        name: 'KSK',
        component: KSK,
        meta: {
            title: 'КСК',
            icon: 'account_circle',
            public: false,
            showInNavigation: true,
            action: 'ksk'
        }
    },
    {
        path: '/requests-ozp/',
        name: 'AHSRequestsOZP',
        component: () => import('../views/ahs-requests/RequestsOZP'),
        meta: {
            title: 'Заявки',
            icon: 'account_circle',
            public: false,
            showInNavigation: true,
            action: 'requestOZPList'
        }
    },
    {
        path: '/requests/new',
        name: 'NewAHSRequest',
        component: () => import('../views/ahs-requests/NewRequest')
    },
    {
        path: '/requests/:id',
        name: 'AHSRequestDetails',
        component: () => import('../views/ahs-requests/RequestDetails')
    },
    {
        path: '/documents',
        name: 'Documents',
        component: Documents,
        meta: {
            title: 'Документы',
            public: false,
            showInNavigation: true,
            action: 'document_view'
        }
    },
    {
        path: '/prescription-ozp',
        name: 'PrescriptionOzp',
        component: PrescriptionOZP,
        meta: {
            title: 'Предписания',
            showInNavigation: true,
            action: 'prescriptionOZPList'
        }
    },
    {
        path: '/prescription-ozp/:id',
        name: 'PrescriptionOZPDetail',
        component: PrescriptionOZPDetail,
        action: 'prescriptionOZPList'
    },
    {
        path: '/request-ozp/:id',
        name: 'RequestOZPDetail',
        component: RequestOZPDetail,
        action: 'prescriptionOZPList'
    },
    {
        path: '/addprescription',
        name: 'addprescription',
        component: AddEditPrescription,
        action: 'prescription_view'
    },
    {
        path: '/editprescription/:id',
        name: 'editprescription',
        component: AddEditPrescription,
        action: 'prescription_view'
    },
    {
        path: '/objecthouses',
        name: 'ObjectHouses',
        component: ObjectHouses,
        meta: {
            title: 'Список объектов / домов',
            public: false,
            showInNavigation: true,
            action: 'object_ksk_view'
        }
    },
    {
        path: '/debtorsList',
        name: 'DebtorsList',
        component: DebtorsList,
        meta: {
            title: 'Список должников',
            showInNavigation: true,
            action: 'debtsList'
        }
    },
    {
        path: '/pre-trial-notices',
        name: 'PreTrialNotices',
        component: PreTrialNotices,
        meta: {
            title: 'Досудебные уведомления',
            showInNavigation: true,
            action: 'pre_trial_notice_list'
        }
    },
    {
        path: '/center-bosses',
        name: 'CenterBosses',
        component: CenterBosses,
        meta: {
            title: 'Начальники ЦОП',
            showInNavigation: true,
            action: 'center_bosses'
        }
    },
    {
        path: '/acts',
        name: 'Acts',
        component: () => import('../views/acts/ActsHome.vue'),
        meta: {
            title: 'Акты на отключение и подключение',
            showInNavigation: true,
            action: 'actList'
        }
    },
    {
        path: '/report_pre_trial_notices_issued',
        name: 'ReportPreTrialNoticesIssued',
        component: ReportPreTrialNoticesIssued,
        meta: {
            title: 'Отчет по выданным Досудебным уведомлениям',
            showInNavigation: true,
            menu: 'reports'
        }
    },
    {
        path: '/report_acts_of_conn_discon',
        name: 'ReportActsOfConnDiscon',
        component: ReportActsOfConnDiscon,
        meta: {
            title: 'Отчет по оформленным Актам на отключение / подключение',
            showInNavigation: true,
            menu: 'reports'
        }
    }
    // {
    //     path: '/stylusSign',
    //     name: 'StylusSign',
    //     component: StylusSign,
    //     meta: {
    //         title: 'StylusSign',
    //         public: false,
    //         showInNavigation: true,
    //         action: 'object_ksk_view'
    //     }
    // }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    const loggedIn = store.getters['auth/loggedIn'];
    const isSystemInMaintenance = store.state.health.isSystemInMaintenance;
    // Не позволять переходить на другие страницы приложения, если идут тех. работы
    if (from.name === 'MaintenanceWorks' && isSystemInMaintenance) return;
    if (!store.state.base.navigationItems.length) {
        try {
            if (loggedIn) {
                await store.dispatch('permissions/getUserPermissions', null, { root: true });
                //await store.dispatch('users/getServOrg', null, { root: true });
                await store.dispatch('users/getUserHeader', null, { root: true });
            }
            await store.dispatch('base/initNavigationItems');
        } catch (e) {
            if (isSystemInMaintenance) return;
            return store.dispatch('auth/logout');
        }
    }
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);

    if (!isPublic && !loggedIn) {
        return next({
            path: '/',
            query: { redirect: to.fullPath } // Store the full path to redirect the user to after login
        });
    }

    if ((loggedIn && onlyWhenLoggedOut) || !to.name || !store.getters['auth/hasPermissionTo'](to.meta.action)) {
        return next('/');
    }

    store.dispatch('base/closeMessage');

    next();
});

export default router;
